import { render, staticRenderFns } from "./UrlField.vue?vue&type=template&id=2512b6e0&scoped=true&"
import script from "./UrlField.vue?vue&type=script&lang=js&"
export * from "./UrlField.vue?vue&type=script&lang=js&"
import style0 from "./UrlField.vue?vue&type=style&index=0&id=2512b6e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2512b6e0",
  null
  
)

export default component.exports